(function ($, Drupal, once) {
  Drupal.behaviors.carouselNoticiasDestaque = {
    attach: function (context, settings) {
      let opts = {
        gap: 10,
        autoWidth: false,
        type: 'slide',
        perPage: 1,
        perMove: 1,
        arrows: true,
        pagination: true,
        autoplay: false,
        interval: 4000,
        autoHeight: false,
      };

      once('carouselNoticiasDestaque', '.carousel-noticias-destaque.splide', context)
        .forEach(function (element) {
          new Splide(element, opts).mount(window.splide.Extensions);
        });
    }
  };
})(jQuery, Drupal, once);
